<div class="dashboard-container">
  <div class="dashboard-title">Hello, {{ user?.name | titlecase }}!</div>
  <!--   <div class="alert alert-light text-center" role="alert">
    <span>More data about your services, venues and usage cooming soon. </span>
  </div> -->

  <div class="dashboard-grid container">
    <div>
      <div class="row justify-content-center">
        <div *ngFor="let shortcut of shortcutsList" class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-3"
          [routerLink]="shortcut.path">
          <button class="shortcut" [disabled]="!shortcut.path">
            <span class="shortcut-title fw-semibold">{{ shortcut.title }}</span>
            <img [src]="shortcut.iconUrl" [alt]="shortcut.title + ' icon'" />
          </button>
        </div>
      </div>
      <div class="row">
        <div id="left-side" class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
          <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12 mb-3">
              <div class="grid-number" attr.data-key="{{ numbers.venues.numbers.key }}"
                *ngIf="numbers.venues.numbers.key !== 'domains'">
                <div class="grid-number-wrapper">
                  <!--                   <div class="grid-number-wrapper-icon">
                    <img [src]="numbers.venues.numbers.icon" />
                  </div> -->
                  <div class="grid-number-wrapper-rows">
                    <div class="grid-number-wrapper-row">
                      <span class="sub-value">{{ numbers.venues.numbers.text }} </span>
                    </div>
                    <div class="grid-number-wrapper-row">
                      <div class="d-flex align-items-center">
                        <span class="main-value">{{ numbers.venues.numbers.value | number: '' : 'en' }}</span>
                        <span class="custom-loader-spin" *ngIf="loadingnumbers"></span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="numbers.venues.numbers.items && numbers.venues.numbers.items.length">
                    <ul>
                      <li *ngFor="let i of numbers.venues.numbers.items">
                        <span>{{ i.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mb-3">
              <div class="grid-number" attr.data-key="{{ numbers.venues.numbers.key }}"
                *ngIf="numbers.venues.numbers.key !== 'domains'">
                <div class="grid-number-wrapper">
                  <!--                   <div class="grid-number-wrapper-icon">
                    <img [src]="numbers.venues.numbers.icon" />
                  </div> -->
                  <div class="grid-number-wrapper-rows">
                    <div class="grid-number-wrapper-row">
                      <span class="sub-value">{{ numbers.configurations.numbers.text }}</span>
                    </div>
                    <div class="grid-number-wrapper-row">
                      <div class="d-flex align-items-center">
                        <span class="main-value">{{ numbers.configurations.numbers.value | number: '' : 'en' }}</span>
                        <span class="custom-loader-spin" *ngIf="loadingnumbers"></span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="numbers.configurations.numbers.items && numbers.configurations.numbers.items.length">
                    <ul>
                      <li *ngFor="let i of numbers.configurations.numbers.items">
                        <span>{{ i.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-3">
              <video width="100%" height="auto" controls autoplay>
                <source src="/assets/videos/preview-2dmapseditor.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <!--             <div class="col-sm-12 mb-3">
              <carousel [showIndicators]="false">
                <slide>
                  <img src="/assets/img/dashboard/sliders/1.png" style="display: block; width: 100%" />
                  <div class="carousel-caption d-none d-md-block">
                    <h3>Venue Maps</h3>
                    <p>
                      Experience the advantages of having a virtual representation of your venue with our 3D Digital
                      Venue platform.
                    </p>
                    <div class="d-flex justify-content-center d-none">
                      <a class="btn-main" href="https://3ddigitalvenue.com/solutions" target="_blank"> See more </a>
                    </div>
                  </div>
                </slide>
                <slide>
                  <img src="/assets/img/dashboard/sliders/2.png" style="display: block; width: 100%" />
                  <div class="carousel-caption d-none d-md-block">
                    <h3>Seating Charts</h3>
                    <p>
                      We meticulously recreate the seating chart layout in 2D or 3D formats, providing a comprehensive
                      and visually captivating overview of your venue with just a glance.
                    </p>
                    <div class="d-flex justify-content-center d-none">
                      <a class="btn-main" href="https://3ddigitalvenue.com/solutions" target="_blank"> See more </a>
                    </div>
                  </div>
                </slide>
                <slide>
                  <img src="/assets/img/dashboard/sliders/3.png" style="display: block; width: 100%" />
                  <div class="carousel-caption d-none d-md-block">
                    <h3>Ticketing Integration</h3>
                    <p>
                      Our intuitive API allows for a simple integration, ensuring a smooth and efficient connection
                      between your ticketing platform and our Cloud Service.
                    </p>
                    <div class="d-flex justify-content-center d-none">
                      <a class="btn-main" href="https://3ddigitalvenue.com/solutions" target="_blank"> See more </a>
                    </div>
                  </div>
                </slide>
                <slide>
                  <img src="/assets/img/dashboard/sliders/4.png" style="display: block; width: 100%" />
                  <div class="carousel-caption d-none d-md-block">
                    <h3>Web Solutions</h3>
                    <p>
                      Our web solutions are designed with your success in mind. We combine cutting edge technology,
                      strategic insights, and creative expertise to develop easy to use online solutions that drive
                      results.
                    </p>
                    <div class="d-flex justify-content-center d-none">
                      <a class="btn-main" href="https://3ddigitalvenue.com/solutions" target="_blank"> See more </a>
                    </div>
                  </div>
                </slide>
                <slide>
                  <img src="/assets/img/dashboard/sliders/5.png" style="display: block; width: 100%" />
                  <div class="carousel-caption d-none d-md-block">
                    <h3>Premium Experiences</h3>
                    <p>Let us take your VIP experiences to new heights and transform your business.</p>
                    <div class="d-flex justify-content-center d-none">
                      <a class="btn-main" href="https://3ddigitalvenue.com/solutions" target="_blank"> See more </a>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div> -->
          </div>
        </div>
        <div id="right-side" class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
          <div class="row">
            <div class="col-xl-5 col-sm-12 mb-3">
              <div class="grid-number" data-size="large" *ngIf="numbers.domains.numbers.key === 'domains'">
                <div class="grid-number-wrapper">
                  <!--                   <div class="grid-number-wrapper-icon">
                    <img [src]="numbers.domains.numbers.icon" />
                  </div> -->
                  <div class="grid-number-wrapper-rows">
                    <div class="grid-number-wrapper-row">
                      <span class="sub-value">{{ numbers.domains.numbers.text }}</span>
                    </div>
                    <div class="grid-number-wrapper-row">
                      <div class="d-flex align-items-center">
                        <span class="main-value">{{ numbers.domains.numbers.value | number: '' : 'en' }}</span>
                        <span class="custom-loader-spin" *ngIf="loadingnumbers"></span>
                      </div>
                    </div>
                  </div>
                  <div class="right-side-content"
                    *ngIf="numbers.domains.numbers.items && numbers.domains.numbers.items.length">
                    <ul>
                      <li *ngFor="let i of numbers.domains.numbers.items">
                        <span>{{ i.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-7">
              <div class="grid-updates">
                <span class="grid-updates-title">Latest Configurations</span>
                <div class="grid-update-body">
                  <ul class="list-unstyled m-0" *ngIf="lastConfigurations.length; else nodata">
                    <li *ngFor="let item of lastConfigurations">
                      <div class="item">
                        <span class="bullet bg-green"></span>
                        <span class="item-content ps-2">
                          <div>
                            {{ item.code }}
                          </div>
                          <div>
                            <b>{{ item.venue?.name }}</b> | {{ item.venue?.venuetype.name.toUpperCase() }} |
                            {{ item.venue?.city }}
                          </div>
                        </span>
                      </div>
                    </li>
                  </ul>
                  <ng-template #nodata>
                    <span>Contact us to start using your 3D Digital Venue.</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</div>